<template>
    <div class="team-seach" :class="{ 'team-seach_zh': this.lang == 'zh_CN', 'team-seach_en': this.lang != 'zh_CN' }">
        <div>
            <el-select v-model="planStatus" :placeholder="$t('planHome.QXZ')" size="small" @change="seach">
                <div class="prefix" slot="prefix">{{ $t('planHome.LXZT') }}</div>
                <el-option :label="$t('planHome.QBZT')" value=""></el-option>
                <el-option :label="$t('planHome.JXZ')" value="1"></el-option>
                <el-option :label="$t('planHome.WKT')" value="0"></el-option>
                <el-option :label="$t('planHome.YJS')" value="2"></el-option>
            </el-select>
            <el-input v-model="searchContent" @keyup.enter.native="seach" style="margin: 0 16px;"
                :placeholder="$t('planHome.QSRLXMC')" size="small"></el-input>
            <el-button type="primary" size="small" @click="seach">{{ $t('planHome.CX') }}</el-button>
        </div>
        <div class="layout_box">
            <img
                v-if="currentLayout === 'table'" 
                :title="$t('planHome.QHWKBJ')"
                @click="$emit('changeLayout', 'block')"
                src="@/assets/image/homePage/block_bj.png" />
            <img 
                v-else
                @click="$emit('changeLayout', 'table')"
                src="@/assets/image/homePage/table_bj.png"
                :title="$t('planHome.QHWKBJ')" />
        </div>
    </div>
</template>
<script>
import { getStore } from '@/utils/common'

export default {
    name: 'team-seach',
    data() {
        return {
            lang: getStore('lang') || 'zh_CN',
            searchContent: '',
            planStatus: '',
            
        }
    },
    props:{
        currentLayout: {
            type: String,
            default: 'block'
        }
    },
    watch: {
        $route() {
            this.searchContent = '',
                this.planStatus = ''
        }
    },
    methods: {
        seach() {
            this.$parent.$refs['listBox'].getList()
        }
    }
}
</script>
<style scoped lang="scss">
.team-seach{
    display: flex;
    justify-content: space-between;
    .layout_box{
        img{
            width: 24px;
            cursor: pointer;
            height: 24px;
        }
    }
}
.team-seach_zh {
    margin: 16px 0;

    /deep/ .el-select {
        height: 32px;
        border-radius: 2px;

        .el-input__inner {
            background: #F1F2F4;
            padding-left: 72px;
        }

    }

    /deep/ .el-input {
        width: 320px;
        height: 32px;

        opacity: 1;
        border-radius: 2px;

        .el-input__inner {
            background: #F1F2F4;
        }
    }

    .prefix {
        height: 20px;
        font-size: 12px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        line-height: 20px;
        padding: 0 4px;
        margin-top: 7px;
        border-right: solid #ccc 1px;
        color: #A0A0A6;
        -webkit-text-stroke: 1 rgba(255, 255, 255, 0);
        letter-spacing: 1px;
    }
}

.team-seach_en {
    margin: 16px 0;

    /deep/ .el-select {
        height: 32px;
        border-radius: 2px;

        .el-input__inner {
            background: #F1F2F4;
            padding-left: 123px;
        }

    }

    /deep/ .el-input {
        width: 320px;
        height: 32px;

        opacity: 1;
        border-radius: 2px;

        .el-input__inner {
            background: #F1F2F4;
        }
    }

    .prefix {
        height: 20px;
        font-size: 12px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        line-height: 20px;
        padding: 0 4px;
        margin-top: 7px;
        border-right: solid #ccc 1px;
        color: #A0A0A6;
        -webkit-text-stroke: 1 rgba(255, 255, 255, 0);
        letter-spacing: 1px;
    }
}
</style>